import React from 'react';
import get_bundle from '../../domain/get_bundle';
import Email from '../../domain/Email';
import Color from '../../domain/Color';
import Message from '../../components/Message';
import MarkdownComponent from '../../components/MarkdownComponent';
import t from 'tcomb-form';
import { props } from 'tcomb-react';

const FormType = t.struct({
  email: Email
});


@props({
  locale: t.Obj,
  themeBtnColor: t.maybe(Color),
  themeBgColor: t.maybe(Color),
  themeBgFontColor: t.maybe(Color),
  themeBtnFontColor: t.maybe(Color),
  goLogin: t.Func,
  doAcceptCookies: t.Func,
  doResendPassword: t.Func,
  message: t.maybe(t.ReactElement)
})
export default class ResendPassword extends React.Component {

  onSubmit = (evt) => {
    evt.preventDefault();
    var value = this.refs.form.getValue();
    if (value) {
      this.props.doResendPassword(value.email);
    }
  }

  getFormOptions() {
    const bundle = get_bundle(this.props.locale).resend_password;

    return {
      fields: {
        email: {
          help: bundle.email_hint
        }
      }
    };
  };

  getSxContent() {
    const bundle = get_bundle(this.props.locale).login;
    return (
      <div className="left-image">
        <div className="left-claim">
          <div className="cell">
            <MarkdownComponent>{bundle.claim.title}</MarkdownComponent>
          </div>
          <div className="cell">
            <MarkdownComponent>{bundle.claim.remember}</MarkdownComponent>
          </div>
          <div className="cell">
            <MarkdownComponent>{bundle.claim.call_to_action}</MarkdownComponent>
          </div>
        </div>
      </div>
    );
  }

  getDefaultMessage() {
    return (<Message bgColor={this.props.themeBgColor} fontColor={this.props.themeBgFontColor}>{get_bundle(this.props.locale).resend_password.title}</Message>);
  }

  getMessage() {
    if ( this.props.message ) {
      return this.props.message;
    }

    return this.getDefaultMessage();
  }

  render() {

    const { locale } = this.props;
    const bundle = get_bundle(locale).resend_password;

    const btnStyle = {
      backgroundColor: this.props.themeBtnColor,
      color: this.props.themeBtnFontColor
    };

    return (
      <div id="resend_password" className="cols">
        <div className="large-100">
          <div className="cols">
            <div className="large-60 small-hide">
              <div className="cell">
                { this.getSxContent() }
              </div>
            </div>
            <div className="large-40 large-pull-right small-100">
              <div className="cell border-radius-all">
                { this.getMessage() }
                <div id="form" className="box light">
                  <form onSubmit={this.onSubmit}>
                    <t.form.Form
                      ref="form"
                      type={FormType}
                      options={this.getFormOptions()}/>
                    <button className='btn' style={btnStyle}>{bundle.do_resend_password}</button>
                   </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/components/content/ResendPassword.js
 **/